import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18nInstance from '../../i18n/i18n';
import '././header.css';
import l from '../../asserts/logo.png';
import Btn from '../common/btn';

const Head = () => {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [activeLang, setActiveLang] = useState(localStorage.getItem('language') || 'en');

    const toggleMenu = () => setMenuOpen(prev => !prev);
    const closeMenu = () => setMenuOpen(false);

    const changeLanguage = (lang) => {
        if (i18nInstance.changeLanguage) {
            i18nInstance.changeLanguage(lang);
            localStorage.setItem('language', lang);
            setActiveLang(lang);
        } else {
            console.error("i18nInstance.changeLanguage is missing", i18nInstance);
        }
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                closeMenu();
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const isAR = i18nInstance.language === 'ar' || localStorage.getItem('language') === 'ar';
        document.documentElement.dir = isAR ? 'rtl' : 'ltr';
        document.documentElement.lang = i18nInstance.language;
    }, [i18nInstance.language]);

    return (
        <>
            <header className='header'>
                <img className='logo' src={l} alt="logo" />

                <ul className='nav'>
                    <li className='navtext'>{t('nav_events')}</li>
                    <li className='navtext'>{t('nav_categories')}</li>
                    <li className='navtext'>{t('nav_about')}</li>
                    <li className='navtext'>{t('nav_contact')}</li>
                </ul>

                <div className='navv'>
                    <div className='lang-div'>
                        <div className={activeLang === 'en' ? 'lang-btn' : 'lang-btn1'} onClick={() => changeLanguage('en')}>EN</div>
                        <div className={activeLang === 'ar' ? 'lang-btn' : 'lang-btn1'} onClick={() => changeLanguage('ar')}>AR</div>
                    </div>
                    <span className='btn-wrapper'>
                        <Btn btnt={t('signin')} />
                    </span>
                    <button
                        className={`burger ${menuOpen ? 'open' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <span className='burger-line'></span>
                        <span className='burger-line'></span>
                        <span className='burger-line'></span>
                    </button>
                </div>
            </header>

            <div
                className={`mobile-menu-overlay ${menuOpen ? 'open' : ''}`}
                onClick={closeMenu}
            />

            <nav className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
                <img className='mobile-menu-logo' src={l} alt="logo" />

                <button className='mobile-close-btn' onClick={closeMenu} aria-label="Close menu">
                    <p className='head-title'>X</p>
                </button>

                <ul className='mobile-nav'>
                    <li className='mobile-row' onClick={closeMenu}><span className='mobile-navtext'>{t('nav_events')}</span></li>
                    <li className='mobile-row' onClick={closeMenu}><span className='mobile-navtext'>{t('nav_categories')}</span></li>
                    <li className='mobile-row' onClick={closeMenu}><span className='mobile-navtext'>{t('nav_about')}</span></li>
                    <li className='mobile-row' onClick={closeMenu}><span className='mobile-navtext'>{t('nav_contact')}</span></li>
                </ul>

                <Btn btnt={t('signin')} />
            </nav>
        </>
    );
};

export default Head;